<template>
  <div>
    <br/>
    <b-loading :active.sync="isLoading" :is-full-page="true"></b-loading>
    <div class="field">
      <b-input
          v-model="searchFilter"
          icon="magnify"
          placeholder="Search for maps...">
      </b-input>
    </div>
    <!-- <b-table v-if="dataTable" :columns="columns" :data="dataTable"></b-table> -->

    <b-table v-if="dataTable" :data="dataTable">
      <template slot-scope="props">
        <b-table-column v-for="(step, index) in columns" :key="index"
                        :field="step.field"
                        :label="step.label" centered>
          <b-icon v-if="isSuitableForIcon(props.row[step.field])" :icon="getIconForCell(props.row[step.field]).icon"
                  :type="getIconForCell(props.row[step.field]).type"></b-icon>
          <div v-if="!isSuitableForIcon(props.row[step.field])">{{ props.row[step.field] }}</div>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
import displayHelper from '../../helpers/display-helper'
import mapService from '@/services/mapService'
import packService from '@/services/packService'
import gamesService from '@/services/gamesService'
import gameHelper from '@/helpers/game-helper'
import _ from 'lodash'
import GAME_STATUS from '@/enums/gameStatus'

export default {
  name: 'public-games-matrix',
  created() {
    this.generateTableForMapsPacksAndGames()
  },
  data() {
    return {
      isLoading: true,
      maps: [],
      packs: [],
      games: null,
      columns: [],
      searchFilter: null,
      dataTable: [],
    }
  },
  methods: {
    loadMapsList() {
      this.isLoading = true
      const parent = this
      return mapService.getMaps()
          .then((maps) => {
            this.maps = maps
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Oops.. An error occurred: ' + err.message)
          })
          .finally(() => {
            this.isLoading = false
          })
    },
    loadPacksList() {
      this.isLoading = true
      const parent = this
      return packService.getPacks()
          .then((packs) => {
            this.packs = packs
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Oops.. An error occurred: ' + err.message)
          })
          .finally(() => {
            this.isLoading = false
          })
    },
    loadGamesList() {
      this.isLoading = true
      const parent = this
      return gamesService.getGames()
          .then((games) => {
            this.games = gameHelper.formatGames(games)
          })
          .catch((error) => {
            displayHelper.displayError(parent, 'Oops, there was an error while loading the games: ' + error.message)
          })
          .finally(() => {
            this.isLoading = false
          })
    },
    isSuitableForIcon(content) {
      return _.isBoolean(content) || content === 'N/A' || _.values(GAME_STATUS).includes(content)
    },
    getIconForCell(content) {
      if (content === 'N/A') {
        return {icon: 'cancel', type: 'is-light'}
      }
      switch (content) {
        case GAME_STATUS.NEW:
          return {icon: 'new-box', type: 'is-accent'}
        case GAME_STATUS.PAUSED:
          return {icon: 'pause', type: 'is-info'}
        case GAME_STATUS.PLAYING:
          return {icon: 'play', type: 'is-success'}
        case GAME_STATUS.STOPPED:
          return {icon: 'stop', type: 'is-danger'}
      }
      return {icon: '', type: 'is-success'}
    },
    generateTableForMapsPacksAndGames() {
      this.loadPacksList()
          .then(() => {
            this.loadMapsList()
                .then(() => {
                  let dataTable = []
                  this.loadGamesList()
                      .then(() => {
                        const games = this.games
                        const packs = _.filter(this.packs, function (pack) {
                          return !!pack.rawActivityIds
                        })
                        const packSize = packs.length

                        let packsForColumns = [{label: 'Map/Pack', field: 'mapName'}]
                        let i = 0
                        _.forEach(packs, function (pack) {
                          packsForColumns.push({label: pack.name, field: i.toString()})
                          i++
                        })
                        this.columns = packsForColumns

                        let gameStatus
                        _.forEach(this.maps, function (map) {
                          let theRow = {mapName: map.name}
                          const mapFound = _.find(games, game => {
                            return map.mapId === _.get(game, 'wizardInformation.map.id')
                          })
                          if (mapFound) {
                            let i = 0
                            _.forEach(packs, function (pack) {
                              const packFound = _.find(games, game => {
                                gameStatus = game.gameStatus
                                return pack.packId === _.get(game, 'wizardInformation.chosenPack.packId') &&
                                    map.mapId === _.get(game, 'wizardInformation.map.id')
                              })
                              if (pack.rawActivityIds && pack.rawActivityIds.length < map.geoLocationsCount) {
                                theRow[i] = 'N/A'
                              } else {
                                // theRow[i] = !!packFound
                                theRow[i] = packFound ? gameStatus : false
                              }
                              i++
                            })
                          } else {
                            let i = 0
                            _.forEach(packs, function (pack) {
                              if (pack.rawActivityIds && pack.rawActivityIds.length < map.geoLocationsCount) {
                                theRow[i] = 'N/A'
                              } else {
                                theRow[i] = false
                              }
                              i++
                            })
                          }
                          dataTable.push(theRow)
                        })

                        this.dataTable = dataTable
                      })
                })
          })
    }
  }
}
</script>
